import { render, staticRenderFns } from "./AfectacionTab.vue?vue&type=template&id=70ed7b78&scoped=true"
import script from "./AfectacionTab.vue?vue&type=script&lang=js"
export * from "./AfectacionTab.vue?vue&type=script&lang=js"
import style0 from "./AfectacionTab.vue?vue&type=style&index=0&id=70ed7b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed7b78",
  null
  
)

export default component.exports